import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "../../common/reduxQuery/helpers";
import {
  CategorizationDto,
  CategorizationCreateRequest,
  CategorizationUpdateRequest,
  RecordUsageDto,
} from "../interfaces/configMap";

export const categorizationCrudApi = createApi({
  reducerPath: "categorizationCrudApi",
  baseQuery: customBaseQuery(),
  tagTypes: ["Categorization"],
  endpoints: (build) => ({
    getCategorizations: build.query<
      CategorizationDto[],
      { search?: string; limit?: number } | void
    >({
      query: (arg) => {
        const params: string[] = [];
        if (arg && arg.search) {
          params.push(`search=${encodeURIComponent(arg.search)}`);
        }
        if (arg && arg.limit && arg.limit > 0) {
          params.push(`limit=${arg.limit}`);
        }
        const qs = params.length ? `?${params.join("&")}` : "";
        return {
          url: `/api/v1/categorization${qs}`,
          method: "GET",
        };
      },
      providesTags: ["Categorization"],
    }),

    createCategorization: build.mutation<
      CategorizationDto,
      CategorizationCreateRequest
    >({
      query: (data) => ({
        url: "/api/v1/categorization",
        body: data,
        method: "POST",
      }),
      invalidatesTags: ["Categorization"],
    }),

    updateCategorization: build.mutation<
      CategorizationDto,
      { id: string; data: CategorizationUpdateRequest }
    >({
      query: ({ id, data }) => ({
        url: `/api/v1/categorization/${id}`,
        body: data,
        method: "PUT",
      }),
      invalidatesTags: ["Categorization"],
    }),

    getCategorizationUsage: build.query<RecordUsageDto[], string>({
      query: (id) => ({
        url: `/api/v1/categorization/${id}/usage`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetCategorizationsQuery,
  useLazyGetCategorizationsQuery,
  useCreateCategorizationMutation,
  useUpdateCategorizationMutation,
  useGetCategorizationUsageQuery,
  useLazyGetCategorizationUsageQuery,
} = categorizationCrudApi;
